import { Result, err, ok } from "@jace/api";
import { unwrapOr } from "@zetalabs/core";

const PATTERN = /([^\/]+)\.([^\/\.]+)$/;

interface FileMetadata {
	ext: string;
	name: string;
}

class UnifiedUriParseError extends Error {
	constructor() {
		super("Couldn't parse unified uri");
		this.name = "UnifiedUriError";
	}
}

export function parseUnifiedUri(uri: string): Result<FileMetadata> {
	try {
		const match = uri.match(PATTERN);

		if (!match) {
			throw new UnifiedUriParseError();
		}

		const [, name, ext] = match;

		return ok({ ext, name });
	} catch (e) {
		return err(unwrapOr(e, new UnifiedUriParseError()));
	}
}

export function getFileMetadata(file: File): FileMetadata {
	const fileName = file.name;
	const match = fileName.match(/([^\/]+)\.([^\/\.]+)$/);

	if (!match) {
		throw new Error("Couldn't parse file name");
	}

	const [, name, ext] = match;

	return {
		name,
		ext,
	};
}
